import React from "react";

import PropTypes from "prop-types";
import { FormGroup, FormLabel } from "react-bootstrap";
import FormControl from "react-bootstrap/FormControl";
import { FormattedMessage } from "react-intl";
import ObjectUtils, { coalesce } from "../../../../utils/ObjectUtils";
import ValidatorUtils from "../../../../utils/ValidatorUtils";
import QuestionHeader from "./QuestionHeader";

const { getDeepProperty, findByObjectProp } = ObjectUtils;
const PROPS = "props";
const LENGTH = "length";

const Text = ({
  addIndicatorToQuestion,
  allIndicators,
  changeQuestionField,
  intl,
  libraryQuestion,
  loadIndicators,
  pageName,
  question,
  removeIndicatorFromQuestion,
  setValidator
}) => (
  <QuestionHeader
    changeQuestionField={changeQuestionField}
    pageName={pageName}
    question={question}
    intl={intl}
    addIndicatorToQuestion={addIndicatorToQuestion}
    removeIndicatorFromQuestion={removeIndicatorFromQuestion}
    loadIndicators={loadIndicators}
    allIndicators={allIndicators}
    answered
    libraryQuestion={libraryQuestion}
  >
    {question.type === "infoMessage" ? null : (
      <ConfigComponent
        {...{
          pageName,
          question,
          changeQuestionField,
          setValidator
        }}
      />
    )}
  </QuestionHeader>
);

export default Text;

const ConfigComponent = ({ pageName, question, columnName, setValidator, predefinedProps, editable=true }) => {
  let validatorsProp = coalesce(getDeepProperty(predefinedProps, "validators"), "validators");
  const validators = coalesce(getDeepProperty(question, validatorsProp), []);
  const validator = !columnName
    ? getDeepProperty(validators, 0)
    : findByObjectProp(validators, "columnName", columnName);

  const length = coalesce(ObjectUtils.getDeepProperty(validator, PROPS, LENGTH), "");

  return (
    <FormGroup  className="mb-3">
      <FormLabel>
        <FormattedMessage id="survey.editor.text.maxLength" />
      </FormLabel>
      <FormControl
        type="text"
        disabled={!editable}
        onChange={(event) => {
          const validator = ValidatorUtils.lengthValidator(event.target.value);
          setValidator(pageName, question.name, validator, validatorsProp, columnName);
        }}
        value={length}
      />
    </FormGroup>
  );
};

Text.propTypes = {
  changeQuestionField: PropTypes.func,
  setValidator: PropTypes.func,
  pageName: PropTypes.string,
  columnName: PropTypes.string,
  question: PropTypes.object,
  loadIndicators: PropTypes.func,
  addIndicatorToQuestion: PropTypes.func,
  removeIndicatorFromQuestion: PropTypes.func,
  predefinedProps: PropTypes.object,
  intl: PropTypes.object,
  allIndicators: PropTypes.array
};

ConfigComponent.propTypes = {
  setValidator: PropTypes.func,
  pageName: PropTypes.string,
  columnName: PropTypes.string,
  question: PropTypes.object,
  predefinedProps: PropTypes.object,
  libraryQuestion: PropTypes.object
};
Text.Config = ConfigComponent;
